import React from 'react'
import './BrokerSignUpBtn.css'

export const BrokerSignUpBtn = () => {
  return (
    <>
    <button className='broker_signup_btn' disabled>Broker Features coming soon...</button>
    </>
  )
}